import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("lufso"), parcelRequire.load("Q9f8u"), parcelRequire.load("7KiPh"), parcelRequire.load("bpBCQ"), parcelRequire.load("3btCG")]).then(() => {
let originalModule = parcelRequire("j5Ve0");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("lufso")} />
  <link rel="modulepreload" href={parcelRequire.resolve("Q9f8u")} />
  <link rel="modulepreload" href={parcelRequire.resolve("7KiPh")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("bpBCQ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3btCG")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
